import { Navigate, Outlet, createFileRoute, useRouterState } from '@tanstack/react-router';
import { useApiState } from '../contexts/ApiContext';
import { AccountLayout } from '../components/Layout/AccountLayout';
import { useBusinessQuery } from '../api/businesses';
import { useEffect } from 'react';
import { reportUserId } from '../utils/tracking';
import { ThreeDSNotifications } from '../components/ThreeDS/ThreeDSNotifications';

function AccountGuard() {
  const location = useRouterState({ select: (state) => state.location });
  const state = useApiState();
  const businessQuery = useBusinessQuery({ enabled: state === 'authenticated' });

  useEffect(() => {
    if (businessQuery.data) {
      reportUserId(businessQuery.data.profile.id);
    }
  }, [businessQuery.data]);

  switch (state) {
    case 'authenticated':
      if (location.pathname === '/account') {
        return <Navigate to="/account/home" replace />;
      }

      if (businessQuery.isPending) {
        return null;
      }

      return (
        <AccountLayout>
          <Outlet />
          <ThreeDSNotifications />
        </AccountLayout>
      );
    case 'unauthenticated':
      return <Navigate to="/auth" replace />;
    default:
      return null;
  }
}

export const Route = createFileRoute('/account')({
  component: AccountGuard,
  notFoundComponent: () => <Navigate to="/account/home" replace />,
});
